/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import * as E from ".";

export type Extension = {
	type:
		| "audio"
		| "code"
		| "etc"
		| "excel"
		| "googleSheets"
		| "illustrator"
		| "image"
		| "install"
		| "keynote"
		| "link"
		| "pdf"
		| "photoshop"
		| "ppt"
		| "txt"
		| "video"
		| "voiceRecord"
		| "word"
		| "zip"
		| "hwp"
		| "share3d"
		| "html"
		| "json"
		| "csv"
		| "md"
		| "js"
		| "py"
		| "exe";
};

export default function Extensions({ type }: Extension) {
	switch (type) {
		case "audio":
			return <E.AudioExtension />;
		case "code":
			return <E.CodeExtension />;
		case "etc":
			return <E.EtcExtension />;
		case "excel":
			return <E.ExcelExtension />;
		case "googleSheets":
			return <E.GoogleSheetsExtension />;
		case "illustrator":
			return <E.IllustratorExtension />;
		case "image":
			return <E.ImgExtension />;
		case "install":
		case "exe":
			return <E.InstallExtension />;
		case "keynote":
			return <E.KeynoteExtension />;
		case "link":
			return <E.LinkExtension />;
		case "pdf":
			return <E.PdfExtension />;
		case "photoshop":
			return <E.PhotoshopExtension />;
		case "ppt":
			return <E.PptExtension />;
		case "txt":
		case "html":
		case "json":
		case "csv":
		case "md":
		case "js":
		case "py":
			return <E.TxtExtension />;
		case "video":
			return <E.VideoExtension />;
		case "voiceRecord":
			return <E.VoiceRecordExtension />;
		case "word":
			return <E.WordExtension />;
		case "zip":
			return <E.ZipExtension />;
		case "share3d":
			return <E.Share3DExtension />;
		case "hwp":
			return <E.HwpExtension />;
		default:
			return <E.AudioExtension />;
	}
}
